import { useSiteText } from "../i18n";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BrandMark, Icon } from "./Icon";
import { navigation } from "../data/navigation";
import { useCases } from "../data/useCases";

export function Footer() {
  const txt = useSiteText();
  const { i18n } = useTranslation();
  const groups = [
    { label: "Solutions", items: navigation[0].items! },
    {
      label: "Use Cases",
      items: useCases.map((c) => ({
        label: c.title,
        to: `/use-cases/${c.slug}`,
      })),
    },
    { label: "Platform", items: navigation[2].items! },
    {
      label: "Company",
      items: [
        { label: "About Systein", to: "/about" },
        { label: "Pilots & Research", to: "/evidence" },
        { label: "Resources", to: "/resources" },
        { label: "Contact", to: "/contact" },
      ],
    },
  ];
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-top">
          <div>
            <Link to="/" className="brand" aria-label={txt("Systein home")}>
              <BrandMark />
              <span>{txt("systein.")}</span>
            </Link>
            <p>
              {txt("Human life is continuous.")}
              <br />
              {txt("Support should be too.")}
            </p>
          </div>
          <a className="footer-contact" href="mailto:info@systein.nl">
            {txt("Let’s start a conversation.")}
            <span>
              {txt("info@systein.nl ")}
              <Icon name="arrow" size={20} />
            </span>
          </a>
        </div>
        <div className="footer-links">
          {groups.map((group) => (
            <div key={group.label}>
              <h2>{txt(group.label)}</h2>
              {group.items.map((item) => (
                <Link key={item.to} to={item.to}>
                  {txt(item.label)}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()}{" "}
            {txt(" SYSTEIN Solutions · The Netherlands · KvK 98786350")}
          </p>
          <div>
            <Link to="/Policy">{txt("Privacy")}</Link>
            <Link to="/Terms">{txt("Terms")}</Link>
            <Link to="/Imprint">{txt("Imprint")}</Link>
            <a
              href="https://www.linkedin.com/company/systein-solutions"
              target="_blank"
              rel="noopener noreferrer"
            >
              {txt("LinkedIn ")}
              <span className="sr-only">{txt("(opens in a new tab)")}</span>
            </a>
          </div>
        </div>
        <div className="footer-socials" aria-label={txt("Social profiles")}>
          {[
            [
              "Facebook",
              "https://www.facebook.com/profile.php?id=61588304900875",
            ],
            ["YouTube", "https://www.youtube.com/@Systein_NL"],
            ["Instagram", "https://www.instagram.com/systein_nl/"],
            ["X", "https://x.com/systein_NL"],
          ].map(([label, href]) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {txt(label)}
              <span className="sr-only"> {txt(" (opens in a new tab)")}</span>
            </a>
          ))}
        </div>
        {
          <div className="site-language">
            <label htmlFor="site-language">{txt("Language")}</label>
            <select
              id="site-language"
              value={i18n.language?.split("-")[0] || "en"}
              onChange={(event) => i18n.changeLanguage(event.target.value)}
            >
              <option value="en">{txt("English")}</option>
              <option value="nl">{txt("Nederlands")}</option>
            </select>
          </div>
        }
      </div>
    </footer>
  );
}
